/**
 * @fileoverview Invitation Expired Page
 *
 * This file implements the page displayed when a user clicks on an expired invitation link.
 * It provides information about the expired state and guides users on how to request
 * a new activation link through support.
 *
 * Key features:
 * - Clear error messaging about expired invitation
 * - Support contact link
 * - Consistent branding through Header and Footer components
 */

import React from "react";
import Header from "../commons/Header";
import Footer from "../commons/Footer";
import { Link } from "react-router-dom";

/**
 * InviteExpired Component
 * 
 * Displays a user-friendly message when an invitation link has expired,
 * with instructions on how to request a new activation link through support.
 * 
 * @returns {JSX.Element} A formatted page with expiration message and support link
 */
const InviteExpired = () => {
  /**
   * Constants for branding elements
   * Used by the Header component to maintain consistent application branding
   */
  const headerLogo = `./../assets/img/header-img.svg`;
  const title = "Leader Portal";

  return (
    <div className="mainWrapper">
      {/* Left side image wrapper */}
      <div className="imgWrapper">
        <img
          alt="Landing graphic"
          src={`./../assets/img/onboarding-image.png`}
        />
      </div>
      {/* Right side content wrapper */}
      <div className="rightWrapper">
        <Header headerLogo={headerLogo} title={title} />
        <div className="contentWrapper">
          <h1 className="titleStyle">Your activation link has expired</h1>
          <div className="middleContent">
            <p className="welcomeContent">
              To receive a new activation link, please&nbsp;
              <Link
                className='paragraphStyle'
                rel='noreferrer'
                to={'https://heidricksupport.zendesk.com/hc/en-us'}
                target='_blank'
              >
                Contact Support</Link>
            </p>
          </div>
        </div>
        <Footer />
      </div>
    </div >
  );
};

/**
 * Export the InviteExpired component as the default export
 * This allows it to be imported using:
 * import InviteExpired from './pages/InviteExpired';
 */
export default InviteExpired;
